// var my_accordion = van11yAccessibleAccordionAria();
// my_accordion.attach(document.getElementById('newContent'));

// var other_accordion = van11yAccessibleAccordionAria({
//   ACCORDION_PREFIX_IDS: 'peekaboo_',
//   ACCORDION_JS: 'js-accordion2',
// });
// other_accordion.attach();

import handorgel from 'handorgel';

const init_accordions = () => {
  const Accordions = document.querySelectorAll('.ally-accordion');

  console.log("init_accordions");
  console.log(Accordions);
  console.log(Accordions.length);

  
  if (Accordions.length) {
    for (let i = 0; i < Accordions.length; i++) {
      Accordions[i].classList.add(`accordion-item-${i}`);

      console.log(Accordions[i]);

      /* Instead of using the van11yAccessibleAccordionAria library, we will use the Handorgel JS library */
      /*
      const single_accordion = van11yAccessibleAccordionAria({
        ACCORDION_PREFIX_IDS: 'strand',
        ACCORDION_JS: 'accordion-item-' + i,
      });
      single_accordion.attach();
      */
      /* Use the Handorgel JS library */
      const single_accordion = new handorgel(document.querySelector('.accordion'), {
        // whether multiple folds can be opened at once
        multiSelectable: true,
        // whether the folds are collapsible
        collapsible: true,

        // whether ARIA attributes are enabled
        ariaEnabled: true,
        // whether W3C keyboard shortcuts are enabled
        keyboardInteraction: true,
        // whether to loop header focus (sets focus back to first/last header when end/start reached)
        carouselFocus: true,

        // attribute for the header or content to open folds at initialization
        initialOpenAttribute: 'data-open',
        // whether to use transition at initial open
        initialOpenTransition: true,
        // delay used to show initial transition
        initialOpenTransitionDelay: 200,

        // header/content element selectors or array of elements
        headerElements: '.accordion__header',
        contentElements: '.accordion__content',

        // header/content class if fold is open
        headerOpenClass: 'accordion__header--open',
        contentOpenClass: 'accordion__content--open',

        // header/content class if fold has been opened (transition finished)
        headerOpenedClass: 'accordion__header--opened',
        contentOpenedClass: 'accordion__content--opened',

        // header/content class if fold has been focused
        headerFocusClass: 'accordion__header--focus',
        contentFocusClass: 'accordion__content--focus',

        // header/content class if fold is disabled
        headerDisabledClass: 'accordion__header--disabled',
        contentDisabledClass: 'accordion__content--disabled',
      });
    }
  }
};

/**
 * Init accordion
 */
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.ally-accordion').length > 0) {
    try {
      init_accordions();
    } catch (e) {
      console.log(e);
    }
  }
});
